import React, { Component } from 'react';
import { Form, Segment, Radio, Input, Label, Button, Icon } from 'semantic-ui-react';

class UserType extends Component {

    render() {
        const { applicationId, userType, currentAgentOrAccountant, fileName, readOnly } = this.props;
        const currentLabel = 'Are you the current ' + userType + '?';
        let authorizationLabel = 'You must upload authorization signed by the insured to proceed.', authorizationColor = 'red', authorizationIcon = 'hand paper';

        if (fileName !== '') {
            authorizationLabel = 'Your authorization has been uploaded. You can change or view the form below.';
            authorizationColor = 'orange';
            authorizationIcon = 'exclamation triangle';
        }

        return (
            <div style={{ margin : '1rem 0rem' }}>
            <Segment>
                <Form.Field>
                    <Label color='green' ribbon>Select your user type:</Label>
                </Form.Field>
                <Form.Field>
                <Radio
                    label='Agent'
                    name='userTypeRadioGroup'
                    value='Agent'
                    checked={userType === 'Agent'}
                    onChange={this.props.setUserType}
                    disabled={readOnly}
                />
                </Form.Field>
                <Form.Field>
                <Radio
                    label='Accountant'
                    name='userTypeRadioGroup'
                    value='Accountant'
                    checked={userType === 'Accountant'}
                    onChange={this.props.setUserType}
                    disabled={readOnly}
                />
                </Form.Field>
                <Form.Field>
                <Radio
                    label='Insured'
                    name='userTypeRadioGroup'
                    value='Insured'
                    checked={userType === 'Insured'}
                    onChange={this.props.setUserType}
                    disabled={readOnly}
                />
                </Form.Field>
            </Segment>
            {(userType === 'Agent' || userType === 'Accountant') && (
                <Segment>
                    <Form.Field>
                        <Label color='green' ribbon>{currentLabel}</Label>
                    </Form.Field>
                    <Form.Field>
                    <Radio
                        label='Yes'
                        name='currentAgentOrAccountantRadioGroup'
                        value='Y'
                        checked={currentAgentOrAccountant === 'Y'}
                        onChange={this.props.setCurrentAgentOrAccountant}
                        disabled={readOnly}
                    />
                    </Form.Field>
                    <Form.Field>
                    <Radio
                        label='No'
                        name='currentAgentOrAccountantRadioGroup'
                        value='N'
                        checked={currentAgentOrAccountant === 'N'}
                        onChange={this.props.setCurrentAgentOrAccountant}
                        disabled={readOnly}
                    />
                    </Form.Field>
                </Segment>
            )}
            {(currentAgentOrAccountant === 'N') && (
                <Segment>
                    <Label color={authorizationColor} icon={authorizationIcon} content={authorizationLabel} ribbon />

                    <Form.Field>
                        {(fileName !== '') && (
                            <Button as='div' labelPosition='left' className='file-download'>
                                <Label basic onClick={() => this.props.downloadAttachment(applicationId, 'authorization', fileName)} target='_blank'>
                                    {fileName}
                                </Label>
                                <Button icon onClick={() => this.props.downloadAttachment(applicationId, 'authorization', fileName)} target='_blank'>
                                    <Icon name='download' />
                                </Button>
                            </Button>
                        )}
                        <Input type='file' fluid accept='application/pdf' id='authFormFile' onChange={this.props.onFileChange} disabled={readOnly} />
                    </Form.Field>
                </Segment>
            )}
            </div>
        );
    }
}

export default UserType;